module.exports = __webpack_public_path__ + "static/media/dinosaur(15).59da3914.PNG";